<template>
  <ul class="news-detail-recent">
    <li
      v-for="(article, index) in articles"
      :key="article.id"
      class="py-3"
      :class="{ 'border-bottom border-primary': index < articles.length - 1 }"
    >
      <news-details-recent-item :article="article" />
    </li>
  </ul>
</template>

<script lang="ts">
import type { StrapiArticle } from '~/apollo/types/types';

export default defineComponent({
  props: {
    articles: {
      type: Array as PropType<Array<StrapiArticle>>,
      default: () => [],
    },
  },
});
</script>
